const fontColorOptions = {
  transparent: 'font-transparent',
  white: 'font-white',
  black: 'font-black',
  gray: 'font-gray',
  red: 'font-red',
  green: 'font-green',
  blue: 'font-blue',
  darkblue: 'font-dark-blue',
  shuttlegray: 'font-shuttle-gray'
};

export { fontColorOptions };
//# sourceMappingURL=fontColorOptions.js.map
